import type { JsonResponse } from 'types';

export const getClickIdFromUrl = () => {
  const params = new URLSearchParams(window.location.search);

  return params.get('ttclid');
};

export const getClickId = () => window.gt.ttclid;

export const getClickIdFromSession = async (): Promise<string | null> => {
  const response: JsonResponse<{ clickId: string | null }> = await fetch(`/api/tik-tok/click-id`);

  if (response.status >= 400) {
    throw new Error(`(HTTP ${response.status}) Failed to get TikTok click ID: ${await response.text()}`);
  }

  const { clickId } = await response.json();

  return clickId;
};

export const withTikTokClickId = (data: { [key: string]: any }) => {
  const ttclid = getClickId();

  return {
    ...data,
    ...(ttclid && { ttclid }),
  };
};
